<template>
  <div>
    <myHeader />

    <div class="studio_banner">
      <div class="studio_banner_content">
        <h1 class="fami">hecoos Studio</h1>
        <p style="font-size: 12px">
          Craft each detail with precision. Meticulously manage every phase from
          the conceptualization of the showcase to its eventual, exquisite
          execution.
        </p>
        <div class="callMe" @click="jumpTo('/en/CaseDemonstration#CallMe')">
          Contact us
        </div>
      </div>
      <div class="gradient-bg">
        <svg class="svgBlur">
          <defs>
            <filter id="goo">
              <feGaussianBlur
                in="SourceGraphic"
                stdDeviation="10"
                result="blur"
              ></feGaussianBlur>
              <feColorMatrix
                in="blur"
                mode="matrix"
                values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -8"
                result="goo"
              ></feColorMatrix>
              <feBlend in="SourceGraphic" in2="goo"></feBlend>
            </filter>
          </defs>
        </svg>
        <div class="gradients-container">
          <div class="g1"></div>
          <div class="g2"></div>
          <div class="g3"></div>
          <div class="g4"></div>
          <div class="g5"></div>
          <div class="interactive"></div>
        </div>
      </div>
    </div>

    <div class="bg1">
      <div class="foundation_video">
        <div class="video_start">
          <h1 style="color: white; width: 100%; font-size: 26px">
            Global production process
          </h1>
          <button class="watch-movie-button" @click="showVideo">
            <img
              src="https://download.hecoos.com/enlightv/2025-17/474eb090ad7a5003fcc3f12e09a7120a.png"
              alt=""
            />
          </button>
        </div>
        <!-- <video
          autoplay
          loop
          muted
          src="https://download.hecoos.com/enlightv/2025-17/3e04d9ef0313721c372a09dc4de0cfae.mp4"
        ></video> -->
        <img
          src="https://download.hecoos.com/enlightv/2025-20/74f6eb95683bca36efb3951249c6fdcf.png"
          alt=""
        />
      </div>
    </div>
    <div class="bann3">
      <h1>Key functionalities</h1>

      <mobileStudio :applicationInfo="applicationInfo" />
    </div>
    <div class="bg3">
      <div class="bgbanner">
        <h1>Member Registration</h1>
      </div>
      <div class="sc">
        <div class="register_content">
          <div class="input-group">
            <input type="text" placeholder="Name" v-model="form.rname" />
            <input type="text" placeholder="Company" v-model="form.company" />
          </div>
          <div class="phone-verify-group">
            <div class="phone-verify-container">
              <input
                class="phone-input"
                type="email"
                placeholder="E-mail"
                v-model="form.email"
              />
              <button
                :disabled="!isPhoneValid || isCountingDown"
                @click="obtainCode"
                class="verify-code-button"
              >
                {{ isCountingDown ? ` ${countdown}s` : "Get" }}
              </button>
            </div>
            <input
              type="text"
              placeholder="Verify code"
              v-model="form.verifyCode"
              class="verify-input"
            />
          </div>
          <div class="input-group">
            <input
              type="password"
              placeholder="password"
              v-model="form.password"
            />
            <input
              type="password"
              placeholder="Write your Password again"
              v-model="form.confirmPassword"
            />
          </div>
          <div class="input-group">
            <input type="text" placeholder="City" v-model="form.city" />
            <input type="text" placeholder="Job" v-model="form.position" />
          </div>
          <div class="input-group">
            <select
              placeholder="Seniority"
              :class="{ none_select: !this.form.workDuration }"
              v-model="form.workDuration"
            >
              <option value="" disabled selected>Seniority</option>
              <option v-for="item in workDurationList" :value="item.name">
                {{ item.name }}
              </option>
            </select>
          </div>
          <p class="tip" style="text-align: left">
            To ensure that you can pass the review quickly, please provide
            truthful and valid information
          </p>
          <button
            class="next-button"
            :disabled="!isButtonEnabled"
            @click="goRegister"
          >
            Next step
          </button>
        </div>
      </div>
    </div>
    <div class="bg4">
      <div>
        <h2 class="title">Software subscription</h2>
      </div>
      <div class="subscription-container">
        <div
          v-for="(item, index) in subscriptionOptions"
          :key="index"
          class="subscription-item"
        >
          <h3 class="item-title">{{ item.title }}</h3>
          <div v-if="item.price" class="price">
            {{ item.price }}<span class="z">/weekly plan</span>
          </div>
          <p v-else class="description">{{ item.description }}</p>
          <button class="btn" @click="goToPage(item.path)">learn more +</button>
        </div>
      </div>
    </div>

    <!-- 下载部分和学习方案 -->
    <div class="bg5">
      <div id="app">
        <!-- 下载部分 -->
        <div class="download-section">
          <div class="left-content">
            <img
              src="../../../asset/mobile/mobile_studio/download.png"
              alt="下载图标"
            />
          </div>
          <div class="right-content">
            <h2>Download</h2>
            <p>
              Download now, get familiar with the software, and start creating
              new realities!
            </p>
            <div class="le">
              <button class="download-btn" @click="getdown">
                Software Download
              </button>
              <a href="https://download.hecoos.com/hecoos/hecoosGuide.pdf"
                ><button class="guide-btn">Download guide</button></a
              >
            </div>
          </div>
        </div>
        <!-- 学习方案部分 -->
        <div class="learning-plan-section">
          <div class="right-content">
            <img
              src="../../../asset/mobile/mobile_studio/study.png"
              alt="学习场景"
            />
          </div>
          <div class="left-content">
            <h2>Learning Plan</h2>
            <p>A learning experience that suits your needs and pace</p>
            <div class="le">
              <router-link
                :to="{ name: 'enMobileVideoTutorial' }"
                class="setting_a2"
              >
                <button class="more-btn">Learn more</button>
              </router-link>
              <router-link
                :to="{
                  name: 'enMobile_CaseDemonstration',
                  hash: '#CallMe',
                }"
                class="setting_a2"
              >
                <button class="customize-btn">
                  Customize your learning plan
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <myListen /> -->
    <myInquire />
    <myFooter />
    <videoPlayback
      v-if="showVideoPlayer"
      @close="handleCloseVideo"
      :videoUrl="videoUrl"
    />
  </div>
</template>


<script>
import { getOSSData } from "@/utils/uploadOss.js";
import myHeader from "@/components/en_mobile/myHeader.vue";
import myFooter from "@/components/en_mobile/myFooter.vue";
import mobileStudio from "@/components/en_mobile/mobileStudio.vue";
// import myListen from "@/components/en_mobile/myListen.vue";
import myInquire from "@/components/en_mobile/myInquire.vue";
import videoPlayback from "@/components/en_mobile/videoPlayback.vue";
import axios from "axios";
import { getCaptcha, adminRegister, getEnglishCaptcha } from "@/api/api";
import { Message } from "element-ui";
export default {
  components: {
    // myListen,
    myInquire,
    myHeader,
    myFooter,
    mobileStudio,
    videoPlayback,
  },

  data() {
    return {
      showVideoPlayer: false,
      workDurationList: [
        { name: "1years" },
        { name: "2years" },
        { name: "3years" },
        { name: "4years" },
        { name: "5years" },
        { name: "6years" },
        { name: "7years" },
        { name: "8years" },
        { name: "9years" },
        { name: "More than 10 years" },
      ],
      videoUrl:
        "https://download.hecoos.com/enlightv/2025-17/a7b39397e5b52ac2f16d0e201a71d1f3.mp4",
      bannertext:
        "hecoos以三维可视化界面预演完整的活动过程，精准模拟视频、灯光、机械、交互、导播等舞台元素，艺术家与工程师通过预演协作探讨并清晰确立演出方案的每一处细节，是提升现场执行效率与准确率的坚实保障",
      applicationInfo: [
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-16/b5aecdcaf25f8dbedcd172d81269dc04.PNG",
          title: "3D Previsualization ",
          videoId:'lOEbkxsE424',
          msg: " hecoos uses a 3D visualization interface to pre-visualize the entire event process, accurately simulating stage elements such as video, lighting, mechanics, interaction, and directing. Artists and engineers collaborate through the pre-visualization to discuss and clearly establish every detail of the performance plan, providing a solid guarantee for improving on-site execution efficiency and accuracy. ",
        },
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-16/dee68d234bdb109448c1e11e7731f2e0.PNG",
          title: "Projection Simulation ",
          videoId:'r1hGusBsqE8',
          msg: " Simulate the light path and image distortion of real projectors, accurately measure the illumination and shadowed areas of the projector in real environments, and easily complete the optical path design of various complex models through built-in projectors of multiple brands with different parameters. ",
        },
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-16/b448228ae023f45c1fce4c8395ff4d6a.PNG",
          title: "Lighting Programming ",
          videoId:'rqAiKVDJ_Jc',
          msg: " Lighting effects play a crucial role in setting the stage atmosphere. hecoos integrates mainstream brand lighting fixtures and connects them via the Art-Net protocol, enabling pre-programming of lights, real-time control of actual fixtures on-site, and simulating realistic light and shadow effects in a 3D scene, reproducing the vibrant and colorful lighting effects of the stage.  ",
        },
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-16/98557f4026cd18a7da6d82c0d18a7fe4.PNG",
          title: "Broadcast Control",
          videoId:'l0MLyvM0tro',
          msg: " The system integrates various types of cameras (such as crane cameras, track cameras, etc.), allowing for pre-visualization of camera shots. With a timeline-based control method, it enables precise director switching. Additionally, it can manage and generate electronic scripts based on CUE points, seamlessly connecting directing design with on-site execution. Cloud-based collaboration ensures smooth teamwork, and it can perform unattended director switching tasks. ",
        },
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-16/ac165d73db88a18204ce18210f683fbd.png",
          title: "Live Control ",
          videoId:'7dG6F7x46rM',
          msg: " Studio seamlessly connects the pre-visualization process with on-site execution. As the central control hub for multimedia equipment during the project debugging phase, Studio ensures stable and coordinated operation between devices with its precise communication and control capabilities. Multi-person collaborative debugging makes team coordination smoother and more efficient.  ",
        },
      ],
      formRows: [
        [
          {
            label: "真实姓名",
            type: "input",
            inputType: "text",
            name: "realName",
            placeholder: "Full name", // 添加占位符文本
          },
          {
            label: "邮箱",
            type: "input",
            inputType: "email",
            name: "email",
            placeholder: "Email", // 添加占位符文本
          },
        ],
        [
          {
            label: "手机号",
            type: "input-with-button",
            inputType: "text",
            name: "phone",
            clickHandler: function () {
              this.sendVerificationCode();
            },
            text: "get",
            placeholder: "Phone number", // 添加占位符文本
          },
          {
            label: "验证码",
            type: "input",
            inputType: "text",
            name: "verificationCode",
            placeholder: "Verification code", // 添加占位符文本
          },
        ],
        [
          {
            label: "设置密码",
            type: "input",
            inputType: "password",
            name: "password",
            placeholder: "Create password", // 添加占位符文本
          },
          {
            label: "确认密码",
            type: "input",
            inputType: "password",
            name: "confirmPassword",
            placeholder: "Confirm password", // 添加占位符文本
          },
        ],
        [
          {
            label: "所在公司名称",
            type: "input",
            inputType: "text",
            name: "companyName",
            placeholder: "Company name", // 添加占位符文本
          },
          {
            label: "所在城市",
            type: "input",
            inputType: "text",
            name: "city",
            placeholder: "City", // 添加占位符文本
          },
        ],
        [
          {
            label: "职位",
            type: "input",
            inputType: "text",
            name: "position",
            placeholder: "Position", // 添加占位符文本
          },
          {
            label: "从业时间",
            type: "input",
            inputType: "text",
            name: "workExperience",
            placeholder: "Years in the industry", // 添加占位符文本
          },
        ],
      ],
      formData: {},
      form: {
        rname: "",
        phone: "",
        verifyCode: "",
        password: "",
        confirmPassword: "",
        email: "",
        company: "",
        city: "",
        position: "",
        workDuration: "",
      },
      isCountingDown: false,
      countdown: 60,

      errorMessages: [], // 新增：收集所有错误信息
      isSending: false,

      timer: null,

      subscriptionOptions: [
        {
          title: "Subscription version",
          price: "$12",
          path: "/en/SoftwareSubscriptions",
        },
        {
          title: "Offline version",
          description: `Independent encryption dongle  \n
                        can work offline as well`,
          path: "/en/offlineversion",
        },
      ],

      hue1: 0,
      hue2: 0,
    };
  },
  computed: {
    isButtonEnabled() {
      return (
        // 所有必填字段都填写且密码一致
        this.form.rname &&
        this.form.email &&
        this.form.verifyCode &&
        this.form.password &&
        this.form.confirmPassword &&
        this.form.company &&
        this.form.city &&
        this.form.position &&
        this.form.workDuration &&
        this.form.password === this.form.confirmPassword
      );
    },
    isPhoneValid() {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test(this.form.email);
    },
  },
  methods: {
    handleMouseMove(event) {
      const x = event.clientX / window.innerWidth;
      const y = event.clientY / window.innerHeight;

      this.hue1 = Math.floor(x * 360);
      this.hue2 = Math.floor(y * 360);
    },
    goToPage(path) {
      this.$router.push(path);
    },
    //下载软件接口
    getdown() {
      const config = {
        method: "post", // 请求方法
        url: "https://www.hecoos.com/api/index/hecoosPath", // 请求 URL
        timeout: 5000, // 请求超时时间（毫秒）
      };
      axios(config)
        .then((res) => {
          if (res) {
            const { version, packageUrl } = res.data;
            let file_name = `hecoos Studio v${version}.exe`;
            getOSSData(packageUrl, file_name);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    showVideo() {
      console.log(1);
      this.showVideoPlayer = true;
      document.body.style.overflow = "hidden"; // 禁止页面滚动
    },
    // 处理关闭视频
    handleCloseVideo() {
      this.showVideoPlayer = false;
      document.body.style.overflow = "auto"; // 恢复页面滚动
    },

    jumpTo(url) {
      this.$router.push(url);
    },

    validateField(field) {
      const value = this.form[field];
      let error = "";

      switch (field) {
        case "rname":
          if (!value) error = "Please enter your real name";
          else if (value.length < 2)
            error = "Name must be at least 2 characters long";
          break;
        case "phone":
          if (!value) error = "Please enter your phone number";
          else if (!this.isPhoneValid)
            error = "Please enter a valid phone number";
          break;
        case "email":
          if (!value) error = "Please enter your email address";
          else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value))
              error = "Please enter a valid email address";
          }
          break;
        case "verifyCode":
          if (!value) error = "Please enter the verification code";
          else if (value.length !== 6)
            error = "The verification code is a 6-digit number";
          break;
        case "password":
          if (!value) error = "Please set password";
          else if (value.length < 8)
            error = "Password length should be at least 8 digits";
          else if (!/\d/.test(value) || !/[a-zA-Z]/.test(value))
            error = "Password must contain letters and numbers";
          break;
        case "confirmPassword":
          if (!value) error = "Please confirm password";
          else if (value !== this.form.password)
            error = "Entered passwords differ!";
          break;
        case "company":
          if (!value) error = "Please enter the company name";
          break;
        case "city":
          if (!value) error = "Please enter your city";
          break;
        case "position":
          if (!value) error = "Please enter the position";
          break;
        case "workDuration":
          if (!value) error = "Please enter your employment time";
          break;
      }

      this.errors[field] = error;
      return error;
    },

    // 显示全局错误提示
    showGlobalError(errorMessages) {
      Message({
        message: errorMessages.join("\n"),
        type: "error",
        duration: 5000,
        center: true,
        offset: 60,
      });
    },

    // 获取验证码
    obtainCode() {
      // 先校验邮箱格式
      if (!this.isPhoneValid) {
        Message.error("Please enter the correct email format");
        return;
      }

      let postData = {
        email: this.form.email,
      };
      getEnglishCaptcha(postData).then((res) => {
        if (res.code === 200) {
          Message.success(res.message);
          this.startCountdown();
        } else {
          Message.error(res.message);
        }
      });
    },

    // 姓名校验
    checkZh(str) {
      // ^[A-Za-z]+$ ：仅字母，至少 2 个字符
      let reg = /^[A-Za-z]{2,20}$/;
      return reg.test(str);
    },

    // 公司名称校验
    checkZhCompany(str) {
      // 允许字母、空格、& . ( ) / - ，至少 2 个字符
      let reg = /^[A-Za-z&\/\.\(\) -]{2,}$/;
      return reg.test(str);
    },

    // 验证码校验（假设为6位数字）
    checkVerifyCode(str) {
      let reg = /^\d{6}$/;
      return reg.test(str);
    },

    // 职位校验（至少2个字符，可以是中英文）
    checkPosition(str) {
      let reg = /^.{2,}$/;
      return reg.test(str);
    },
    // 密码校验
    checkPassword(str) {
      return str.length >= 6;
    },
    // 城市校验
    checkCity(str) {
      //允许字母、空格、'-'（如 New York、San Francisco）
      let reg = /^[A-Za-z -]{2,}$/;
      return reg.test(str);
    },
    // 统一表单校验方法
    validateForm() {
      const errors = [];
      // 收集所有错误
      if (!this.form.rname.trim()) errors.push("Please enter your name.");
      if (!this.isPhoneValid)
        errors.push("The email format is incorrect, please re-enter");

      if (this.form.verifyCode && !this.checkVerifyCode(this.form.verifyCode))
        errors.push("Please enter a 6-digit verification code");
      if (this.form.password && !this.checkPassword(this.form.password))
        errors.push("The password length should be at least 6 digits");
      if (this.form.password !== this.form.confirmPassword)
        errors.push("Entered passwords differ!");
      if (!this.form.company.trim()) errors.push("Please enter your company.");
      if (!this.form.city.trim()) errors.push("Please enter the city");
      if (!this.form.position.trim()) errors.push("Please enter your job");
      if (!this.form.workDuration) errors.push("Please choose seniority");

      // 延迟显示错误
      if (errors.length > 0) {
        errors.forEach((msg, index) => {
          setTimeout(() => {
            Message.error(msg);
          }, 500 * index);
        });
        return false;
      }

      return true;
    },
    // 注册
    goRegister() {
      // 执行完整表单校验
      if (!this.validateForm()) {
        return;
      }

      adminRegister(this.form).then((res) => {
        if (res.code === 200) {
          Message.success(res.message);
          this.$router.push("/en/login");
        } else {
          Message.error(res.message);
        }
      });
    },
    startCountdown() {
      this.isCountingDown = true;
      let timer = setInterval(() => {
        this.countdown--;
        if (this.countdown === 0) {
          clearInterval(timer);
          this.isCountingDown = false;
          this.countdown = 60;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/en_mobile/studio_banner.scss";

select {
      display: block;
      width: 100%;
      font-size: 12px;
      padding: 8px 8px;
      border-radius: 6px;
      border: none;
      // margin: 0 10px;
      margin-bottom: 10px;
      background-color: #333333;
      color: #fff;

    }
    select.none_select {
      color: #757575;
    }
    select:focus-visible{
      border: none;
      outline: none;
    }
.callMe {
  width: 80px;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
  background-color: #2a82e4;
  margin: 0 auto;
  color: white;
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  transition: 0.3s ease;
  cursor: pointer;
}

.callMe:hover {
  transform: scale(1.05);
  background-color: #fff;
  color: #2a82e4;
}
</style>
<style scoped lang="scss">
.container {
  position: relative;
  overflow: hidden;
}

.content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 20px;
  border-radius: 10px;
}
.bgc {
  display: flex;
  justify-content: center;
  align-items: center;
  background: url("https://download.hecoos.com/enlightv/2025-17/88bbd52c2dca3a58360b8aa5ad07d60d.png");
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 100vh;
  position: relative;
}

.register_content {
  width: 100%;

  border-radius: 15px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  text-align: center;
  color: #fff;
  position: relative;
  z-index: 1;
}

.register_content h2 {
  margin-bottom: 20px;
  font-size: 32px;
}

.register_content p {
  margin-bottom: 10px;
  font-size: 12px;
}

.input-group {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.input-group input,
.phone-verify-group input {
  width: 48%;
  padding: 10px;
  border: none;
  border-radius: 8px;
  background-color: #333;
  color: #fff;
  font-size: 10px;
  transition: border-color 0.3s;
}

.phone-verify-group {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.phone-verify-container {
  display: flex;
  width: 48%;
  position: relative;
}

.phone-input {
  flex: 1;
  font-size: 18px;
  padding: 10px;
  border: none;
  border-radius: 5px;
  background-color: #333;
  color: #fff;
  width: 100%;
  height: auto;
}

.verify-code-button {
  width: 40px;
  padding: 10px 10px;
  background-color: #333;
  color: #fff;
  border: none;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  height: auto;
  position: absolute;
  right: 0;
  font-size: 10px;
}

.verify-input {
  width: 48%;
  padding: 15px;
  border: none;
  border-radius: 8px;
  background-color: #333;
  color: #fff;
  height: auto;
  font-size: 10px;
}

.next-button {
  width: 100%;
  padding: 10px 0;
  border: none;
  border-radius: 8px;
  background-color: #fff;
  color: #222;
  cursor: pointer;
  margin-bottom: 10px;
  font-size: 10px;
  transition: all 0.3s;
}

.next-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.link-container {
  font-size: 10px;
  color: #fff;
  cursor: pointer;
}
.bg {
  background-image: url("../../../asset/mobile/mobile_studio/cover.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding: 0px 43px;
  height: 36vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.bg1 {
  background: black;
}

.bann3 {
  width: 100%;
  background-color: #000;
  padding: 0 43px;
  color: #fff;
  text-align: center;
}

.bann3 img {
  width: 100%;
}

.bann3 h1 {
  font-size: 26px;
  font-weight: 700;
  color: rgba(255, 255, 255, 1);
  vertical-align: top;
  text-align: center;
  color: white;
  padding: 20px 0px 15px 0;
}

.bann3cent {
  text-align: center;
}

.bann3cent img {
  width: 100%;
}

.bann3cent p {
  font-size: 14px;
  text-align: center;
  color: white;
  font-family: YourFontName2;
}

.contain {
  text-align: center;
}

.contain p {
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
  padding-top: 10px;
}

.banncenter {
  text-align: center;
  padding: 10px 0px;
}

.banncenter video {
  width: 100%;
}

.headbanner h1 {
  font-size: 28px;
  font-weight: 400;
  line-height: 30px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
}

.headbanner p {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 30px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
}

.bg3 {
  background-image: url("../../../asset/mobile/mobile_studio/register.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding: 0px 43px;
}

.form-container {
  margin: 0 auto;
}

.form-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.form-item {
  width: 47%;
  background-color: #24272a;
  border-radius: 10px;
  padding: 10px;
  position: relative;
}

.form-item label {
  display: block;
  margin-bottom: 5px;
  color: #ccc;
}

.form-item input {
  width: 100%;
  border: none;
  border-radius: 5px;
  background-color: #24272a;
  color: #fff;
  font-size: 10px;
}

.form-item input::placeholder {
  font-size: 10px;
}

.input-with-button {
  display: flex;
  align-items: center;
}

.input-with-button input {
  flex: 1;
  margin-right: 10px;
}

.test {
  color: white;
  background-color: transparent;
  border: none;
  cursor: pointer;
  position: absolute;
  left: 80%;
  bottom: 10px;
  font-family: YourFontName2;
  font-size: 11px;
}

.tip {
  color: white;
  margin-bottom: 15px;
  font-size: 13px;
  font-family: YourFontName2;
  padding: 10px 0px;
}

.next-button {
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 20px;
  background-color: #147cf5;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.5s ease;
}

.next-button:hover {
  background-color: white;
  color: #147cf5;
  transform: scale(1.05);
}

.bgbanner h1 {
  font-size: 26x;
  text-align: center;
  color: white;
  padding: 35px 0px;
}

.bg4 {
  background: black;
  padding: 15px 43px 0;
}

.title {
  font-size: 26px;
  text-align: center;
  color: white;
  padding: 35px 0px;
}

.subscription-container {
  background-color: #000;
  color: #fff;
  padding: 0 0 15px 0;
}

.subscription-item {
  background-color: #232428;
  border-radius: 15px;
  text-align: center;

  transition: all 0.3s ease;
  margin: 50px 0 0 0;
}

.subscription-item:nth-child(1) {
  margin-top: 0;
}

.subscription-item:hover {
  box-shadow: 5px 5px 20px #147cf5;
}

.item-title {
  font-size: 20px;
  text-align: center;
  background: linear-gradient(
    to right,
    rgba(234, 212, 254, 1),
    rgba(40, 189, 181, 1)
  );
  /* 定义渐变方向和颜色 */
  -webkit-background-clip: text;
  /* 裁剪背景以适应文字形状，Webkit内核 */
  background-clip: text;
  /* 裁剪背景以适应文字形状，标准语法 */
  color: transparent;
  padding: 20px 0 5px 0;
}

.price {
  font-size: 20px;
  padding: 15px 0;
}

.z {
  font-size: 12px;
}

.description {
  padding: 15px 10px;
  font-size: 12px;
}

.btn {
  background-color: #147cf5;
  color: white;
  padding: 5px 40px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  transition: background 0.3s ease;
  margin: 20px 0;
}

.btn:hover {
  background: linear-gradient(to right, #e0004a, #e22d8e);
}

.bg5 {
  background: black;
}

#app {
  color: white;
  background-color: #000;
  padding: 40px 43px;
}

.bg5 #app {
  padding-top: 0;
}

.left-content img {
  width: 100%;
  padding: 40px 0;
}

.left-content h2,
.right-content h2 {
  margin-bottom: 20px;
  font-size: 26px;
  vertical-align: top;
  text-align: left;
}

.left-content p,
.right-content p {
  margin-bottom: 30px;
  vertical-align: top;
  text-align: left;
  font-size: 12px;
}

.right-content img {
  width: 100%;
  padding: 40px 0;
}

.download-btn,
.guide-btn,
.more-btn,
.customize-btn {
  padding: 10px 9px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  vertical-align: bottom;
  font-size: 12px;
}

.download-btn,
.more-btn {
  margin-right: 15px;
  padding: 11px 10px;
}

// .customize-btn:last-child{
//   margin-right: 0;
// }
.le {
  text-align: left;
  vertical-align: bottom;
}

.download-btn,
.more-btn {
  background-color: #147cf5;
  color: white;
  border-radius: 30px;
  transition: all 0.5s ease;
}

.download-btn:hover,
.more-btn:hover {
  background-color: white;
  color: #147cf5;
  transform: scale(1.05);
}

.guide-btn,
.customize-btn {
  background-color: #000000;
  color: white;
  border: 1px solid white;
  border-radius: 30px;
  transition: all 0.5s ease;
}

.guide-btn:hover,
.customize-btn:hover {
  transform: scale(1.05);
  background-color: white;
  color: #000;
}

.foundation_video {
  width: 100%;
  position: sticky;
  top: 0;
  justify-content: center;
  align-items: center;

  object-fit: cover;

  img {
    width: 100%;
    object-fit: cover;
  }
}

.watch-movie-button {
  width: 32px;
  height: 32px;
  border-radius: 36.65px;
  border: 2px solid white;
  background-color: rgba(0, 0, 0, 0.1);
}

.video_start {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 999;
  width: 100%;
}

.video_start img {
  width: 100%;
}

.foundation_video video {
  width: 100%;
  object-fit: cover;
}

@media screen and (min-width: 768px) {

  select {
      display: block;
      width: 100%;
      font-size: 18px;
      padding: 20px 8px;
      border-radius: 6px;
      border: none;
      // margin: 0 10px;
      margin-bottom: 10px;
      background-color: #333333;
      color: #fff;

    }
    select.none_select {
      color: #757575;
    }
    select:focus-visible{
      border: none;
      outline: none;
    }
  .input-group input,
  .phone-verify-group input {
    width: 48%;
    padding: 20px;
    border: none;
    border-radius: 8px;
    background-color: #333;
    color: #fff;
    font-size: 18px;
    transition: border-color 0.3s;
  }
  .callMe {
    width: 180px;
    height: 50px;
    line-height: 50px;
    border-radius: 30px;
    background-color: #2a82e4;
    margin: 0 auto;
    margin-top: 20px;
    font-size: 18px;
    transition: 0.3s ease;
    cursor: pointer;
  }

  .callMe:hover {
    transform: scale(1.05);
    background-color: #fff;
    color: #2a82e4;
  }

  .container {
    position: relative;
    overflow: hidden;
  }

  .content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.5);
    padding: 20px;
    border-radius: 10px;
  }

  .bg {
    background-image: url("../../../asset/mobile/mobile_studio/cover.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    padding: 0px 43px;
    height: 36vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .bg1 {
    background: black;
  }

  .bann3 {
    width: 100%;
    background-color: #000;
    padding: 30px;
    color: #fff;
    text-align: center;
  }

  .bann3 img {
    width: 100%;
  }

  .bann3 h1 {
    font-size: 40px;
    font-weight: 700;
    color: rgba(255, 255, 255, 1);
    vertical-align: top;
    text-align: center;
    color: white;
    padding: 0px 0px 30px 0;
  }

  .bann3cent {
    text-align: center;
  }

  .bann3cent img {
    width: 100%;
  }

  .bann3cent p {
    font-size: 14px;
    text-align: center;
    color: white;
    font-family: YourFontName2;
  }

  .contain {
    text-align: center;
  }

  .contain p {
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    vertical-align: top;
    padding-top: 10px;
  }

  .banncenter {
    text-align: center;
    padding: 10px 0px;
  }

  .banncenter video {
    width: 100%;
  }

  .headbanner h1 {
    font-size: 28px;
    font-weight: 400;
    line-height: 30px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    vertical-align: top;
  }

  .headbanner p {
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 30px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    vertical-align: top;
  }

  .bg3 {
    background-image: url("../../../asset/mobile/mobile_studio/register.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    padding: 0px 43px;
  }

  .form-container {
    margin: 0 auto;
  }

  .form-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
  }

  .form-item {
    width: 47%;
    background-color: #24272a;
    border-radius: 10px;
    padding: 10px;
    position: relative;
  }

  .form-item label {
    display: block;
    margin-bottom: 5px;
    color: #ccc;
  }

  .form-item input {
    width: 100%;
    border: none;
    border-radius: 5px;
    background-color: #24272a;
    color: #fff;
    font-size: 18px;
  }

  .form-item input::placeholder {
    font-size: 18px;
  }

  .input-with-button {
    display: flex;
    align-items: center;
  }
  .verify-code-button {
    width: 120px;
    padding: 20px;
    background-color: #333;
    color: #fff;
    border: none;
    border-radius: 0 5px 5px 0;
    cursor: pointer;
    height: auto;
    position: absolute;
    right: 0;
    font-size: 18px;
  }

  .input-with-button input {
    flex: 1;
    margin-right: 10px;
  }

  .test {
    color: white;
    background-color: transparent;
    border: none;
    cursor: pointer;
    position: absolute;
    left: 87%;
    bottom: 10px;
    font-family: YourFontName2;
    font-size: 18px;
  }
  .register_content p {
    margin-bottom: 10px;
    font-size: 18px;
  }
  .tip {
    color: white;
    margin-bottom: 15px;
    font-size: 18px;
    font-family: YourFontName2;
    padding: 10px 0px;
  }

  .next-button {
    width: 100%;
    padding: 10px;
    border: none;
    border-radius: 20px;
    background-color: #147cf5;
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    transition: all 0.5s ease;
  }

  .next-button:hover {
    background-color: white;
    color: #147cf5;
    transform: scale(1.05);
  }

  .bgbanner h1 {
    font-size: 40px;
    text-align: center;
    color: white;
    padding: 35px 0px;
  }

  .bg4 {
    background: black;
    padding: 15px 43px 0;
  }

  .title {
    font-size: 40px;
    text-align: center;
    color: white;
    padding: 35px 0px;
  }

  .subscription-container {
    background-color: #000;
    color: #fff;
    padding: 0 0 15px 0;
  }

  .subscription-item {
    background-color: #232428;
    border-radius: 15px;
    text-align: center;
    padding: 40px 0;
    transition: all 0.3s ease;
    margin: 50px 0 0 0;
  }

  .subscription-item:nth-child(1) {
    margin-top: 0;
  }

  .subscription-item:hover {
    box-shadow: 5px 5px 20px #147cf5;
  }

  .item-title {
    font-size: 40px;
    text-align: center;
    background: linear-gradient(
      to right,
      rgba(234, 212, 254, 1),
      rgba(40, 189, 181, 1)
    );
    /* 定义渐变方向和颜色 */
    -webkit-background-clip: text;
    /* 裁剪背景以适应文字形状，Webkit内核 */
    background-clip: text;
    /* 裁剪背景以适应文字形状，标准语法 */
    color: transparent;
    padding: 20px 0 5px 0;
  }

  .price {
    font-size: 35px;
    padding: 15px 0;
  }

  .z {
    font-size: 18px;
  }

  .description {
    padding: 15px 10px;
    font-size: 26px;
  }

  .btn {
    background-color: #147cf5;
    color: white;
    padding: 5px 40px;
    font-size: 18px;
    height: 50px;
    border: none;
    border-radius: 30px;
    cursor: pointer;
    transition: background 0.3s ease;
    margin: 20px 0;
  }

  .btn:hover {
    background: linear-gradient(to right, #e0004a, #e22d8e);
  }

  .bg5 {
    background: black;
  }

  #app {
    color: white;
    background-color: #000;
    padding: 40px 43px;
  }

  .bg5 #app {
    padding-top: 0;
  }

  .left-content img {
    width: 100%;
    padding: 40px 0;
  }

  .left-content h2,
  .right-content h2 {
    margin-bottom: 20px;
    font-size: 40px;
    vertical-align: top;
    text-align: left;
  }

  .left-content p,
  .right-content p {
    margin-bottom: 30px;
    vertical-align: top;
    text-align: left;
    font-size: 18px;
  }

  .right-content img {
    width: 100%;
    padding: 40px 0;
  }

  .download-btn,
  .guide-btn,
  .more-btn,
  .customize-btn {
    padding: 10px 9px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    vertical-align: bottom;
    font-size: 18px;
  }

  .download-btn,
  .more-btn {
    margin-right: 15px;
    padding: 11px 10px;
  }

  // .customize-btn:last-child{
  //   margin-right: 0;
  // }
  .le {
    text-align: left;
    vertical-align: bottom;
  }

  .download-btn,
  .more-btn {
    background-color: #147cf5;
    color: white;
    border-radius: 30px;
    transition: all 0.5s ease;
  }

  .download-btn:hover,
  .more-btn:hover {
    background-color: white;
    color: #147cf5;
    transform: scale(1.05);
  }

  .guide-btn,
  .customize-btn {
    background-color: #000000;
    color: white;
    border: 1px solid white;
    border-radius: 30px;
    transition: all 0.5s ease;
  }

  .guide-btn:hover,
  .customize-btn:hover {
    transform: scale(1.05);
    background-color: white;
    color: #000;
  }

  .foundation_video {
    width: 100%;
    position: sticky;
    top: 0;
    justify-content: center;
    align-items: center;

    object-fit: cover;

    img {
      width: 100%;
      object-fit: cover;
    }
  }

  .watch-movie-button {
    width: 46px;
    height: 46px;
    border-radius: 36.65px;
    border: 2px solid white;
    background-color: rgba(0, 0, 0, 0.1);
  }

  .video_start {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 999;
    width: 100%;
    h1 {
      font-size: 40px !important;
    }
  }

  .video_start img {
    width: 100%;
  }

  .foundation_video video {
    width: 100%;
    object-fit: cover;
  }
  .studio_banner_content p {
    font-size: 20px !important;
  }
}
</style>
